import { Button, makeStyles } from '@material-ui/core';
import { withUpdatePaymentStatus } from 'components/common/permissions';
import { handleStopPropagation, PAL_FUNDING_DC_TYPE } from 'consts';
import { loadUpdatePayment } from 'model/transactionHistory';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { derivedSelectorId } from 'selectors/transactionHistory';
import { isOn } from 'util/index';
import { isNOCOrNOA } from './consts';
import UpdatePaymentDialog from './UpdatePaymentDialog';

const useStyles = makeStyles((theme) => ({
  button: {
    marginRight: theme.spacing(1),
  },
}));

const UpdatePayment = ({
  id,
  transaction: transactionProp,
  onUpdateSuccess,
}) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const ormTransaction = useSelector((state) =>
    derivedSelectorId(state, { id })
  );
  const transaction = transactionProp ?? ormTransaction;
  const converted = isOn(transaction?.conversionDataOffOn);
  const isDebitCard = transaction?.dcType === PAL_FUNDING_DC_TYPE;
  const show = !converted && !isDebitCard && isNOCOrNOA(transaction);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);
  const handleOpen = (event) => {
    handleStopPropagation(event);
    setOpen(true);
    dispatch(loadUpdatePayment({ id: transaction.id }));
  };

  return show ? (
    <>
      <Button
        className={classes.button}
        onClick={handleOpen}
        role="button"
        variant="outlined"
      >
        Update Payment
      </Button>
      {open && (
        <UpdatePaymentDialog
          id={id}
          onClick={handleStopPropagation}
          onClose={handleClose}
          onUpdateSuccess={onUpdateSuccess}
          open
          transaction={transactionProp}
        />
      )}
    </>
  ) : null;
};

UpdatePayment.propTypes = {
  id: PropTypes.number.isRequired,
  onUpdateSuccess: PropTypes.func,
  transaction: PropTypes.object,
};

UpdatePayment.defaultProps = {
  onUpdateSuccess: undefined,
  transaction: undefined,
};

export default withUpdatePaymentStatus(UpdatePayment);
